import Link from 'next/link';
import ReactMarkdown from 'react-markdown';

import { Accordion } from '@endaoment-frontend/ui/shared';

import { FAQS } from '../../../editable';

import styles from './FAQ.module.scss';
import { FAQProps } from './FAQSection.types';

const FAQ = ({ title, questions, id }: FAQProps) => {
  return (
    <div className={styles['faq']} id={id}>
      <span className={styles['faq-title']}>{title}</span>
      <hr />
      {questions.map(({ question, answer }, i) => (
        <Accordion
          key={i}
          outerContent={<span className={styles['accordion-question']}>{question}</span>}
          className={styles['faq-accordion']}
        >
          <ReactMarkdown
            className={styles['accordion-answer']}
            components={{
              a: ({ children, href }) => (
                <Link href={href}>
                  <a>{children}</a>
                </Link>
              ),
            }}
          >
            {answer}
          </ReactMarkdown>
        </Accordion>
      ))}
    </div>
  );
};

export const FAQSection = () => {
  return (
    <section className={styles['faq-section']} id="faq-section">
      <h2>Frequently Asked Questions</h2>
      {FAQS.map((faq, i) => (
        <FAQ key={i + faq.title} id={`faq-${i + 1}`} {...faq} />
      ))}
    </section>
  );
};
